export const defaultTheme = {
	colorMode: 'auto',
	dark: 'dark',
	light: 'light',
	spacing: 'spacing',
	typography: 'typography',
} as const;
